import { StripUnderscore, UnderscoreKeys } from "../util/Types";
import { PagePalette } from "./StoryBase";
import { UserOwnedClass, userOwnedSchema } from "./UserOwnedClass";
import z from "zod";

export const abstractOrderLineItemSchema = userOwnedSchema.extend({
  _storyId: z.string().nonempty(),
  _quantity: z.number(),
  _title: z.string().nonempty(),
  _author: z.string().nonempty(),
  _frontPageImagePath: z.string().nonempty(),
  _frontPagePalette: z.any(),
  _luluSku: z.string().nonempty(),
  _formatId: z.string().nonempty(),
  _unitPrice: z.string().optional(),
});

export type AbstractOrderLineItemFields = StripUnderscore<z.infer<typeof abstractOrderLineItemSchema>>;
export abstract class AbstractOrderLineItem<TFields extends AbstractOrderLineItemFields> extends UserOwnedClass<TFields> {
	private _storyId!: string;
	private _quantity!: number;
	private _title!: string;
	private _author!: string;
	private _frontPageImagePath!: string;
	private _frontPagePalette!: PagePalette;
	private _luluSku!: string;
	private _formatId!: string;
	protected _unitPrice: string | undefined;

	constructor(props: Partial<TFields>) {
		super(props);
	}
	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [...super.getFieldList(), "_storyId", "_quantity", "_title", "_author", "_frontPageImagePath", "_frontPagePalette","_luluSku", "_formatId", "_unitPrice"];
	}
	override validateSchema(): void {
		abstractOrderLineItemSchema.parse(this);
	}
	get storyId(): string {
		return this.checkFieldType<"storyId">(this._storyId);
	}
	set storyId(value: string) {
		this._storyId = this.checkFieldTypeAndMark<"storyId">("_storyId", value);
	}

	get quantity(): number {
		return this.checkFieldType<"quantity">(this._quantity);
	}
	set quantity(value: number) {
		this._quantity = this.checkFieldTypeAndMark<"quantity">("_quantity", value);
	}

	get title(): string {
		return this.checkFieldType<"title">(this._title);
	}
	set title(value: string) {
		this._title = this.checkFieldTypeAndMark<"title">("_title", value);
	}

	get author(): string {
		return this.checkFieldType<"author">(this._author);
	}
	set author(value: string) {
		this._author = this.checkFieldTypeAndMark<"author">("_author", value);
	}

	get frontPageImagePath(): string {
		return this.checkFieldType<"frontPageImagePath">(this._frontPageImagePath);
	}
	set frontPageImagePath(value: string) {
		this._frontPageImagePath = this.checkFieldTypeAndMark<"frontPageImagePath">("_frontPageImagePath", value);
	}

	get frontPagePalette(): PagePalette {
		return this.checkFieldType<"frontPagePalette">(this._frontPagePalette);
	}
	set frontPagePalette(value: PagePalette) {
		this._frontPagePalette = this.checkFieldTypeAndMark<"frontPagePalette">("_frontPagePalette", value);
	}

	get luluSku(): string {
		return this.checkFieldType<"luluSku">(this._luluSku);
	}
	set luluSku(value: string) {
		this._luluSku = this.checkFieldTypeAndMark<"luluSku">("_luluSku", value);
	}

	get formatId(): string {
		return this.checkFieldType<"formatId">(this._formatId);
	}
	set formatId(value: string) {
		this._formatId = this.checkFieldTypeAndMark<"formatId">("_formatId", value);
	}

	get unitPrice(): string | undefined {
		return this.checkFieldType<"unitPrice">(this._unitPrice);
	}
	set unitPrice(value: string) {
		this._unitPrice = this.checkFieldTypeAndMark<"unitPrice">("_unitPrice", value);
	}
}
